import { combineReducers } from 'redux';

import apiError from './apiError';
import data from './data';
import isFetching from './isFetching';

/**
 * @typedef {{
 *  apiError: string,
 *  isFetching: boolean,
 *  data: Array<import('modules/statistics/types').InterventionRatingReducer>
 * }} StatisticsInterventionRatingReducer
 */

export default combineReducers({
  data,
  apiError,
  isFetching,
});
